import { createFileRoute } from "@tanstack/react-router";
import { RiskFlaggingPage } from "@/components/risk-flagging";

export const Route = createFileRoute("/_authenticated/risk-flagging/")({
  component: RiskFlaggingPage,
});
